import { useLocation } from "wouter";
import { initiateOAuthFlow } from "@/lib/oauth";

function useConnectWithX() {
  const [location] = useLocation();

  const connectWithX = async () => {
    const VITE_X_REDIRECT_URI = import.meta.env.VITE_X_REDIRECT_URI;
    const redirectUri = `${VITE_X_REDIRECT_URI}/oauth/callback`;
    await initiateOAuthFlow(redirectUri, location);
  };

  return {
    connectWithX,
  };
}

export default useConnectWithX;
